import { createFileRoute } from "@tanstack/react-router";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import { Hero } from "@/components/Hero";
import { Reveal } from "@/components/Reveal";

export const Route = createFileRoute("/impressum")({
  head: () => ({
    meta: [
      { title: "Impressum — Tarifvergleiche.com" },
      {
        name: "description",
        content: "Impressum und Anbieterkennzeichnung von Tarifvergleiche.com.",
      },
    ],
  }),
  component: ImpressumPage,
});

function ImpressumPage() {
  return (
    <main className="relative">
      <SiteNav />

      <Hero eyebrow="Rechtliches" title="Impressum" subtitle="Angaben gemäß § 5 TMG." />

      <section className="relative pb-32 px-6">
        <div className="mx-auto max-w-2xl">
          <Reveal>
            <div className="relative rounded-2xl border border-foreground/12 bg-card p-8 md:p-10 ticket-shadow">
              <span className="punch-hole" />

              <div className="space-y-1 text-foreground">
                <p className="font-display font-semibold">iMPLI Informations-Systeme GmbH</p>
                <p>Mellerswiesen 17</p>
                <p>34125 Kassel</p>
              </div>

              <p className="mt-6 text-sm text-muted-foreground">
                Unternehmenssitz: <span className="text-foreground">Paderborn</span>
              </p>

              <div className="my-6 text-foreground/20">
                <div className="barcode-rule" />
              </div>

              <div className="space-y-3 text-sm">
                <div className="flex items-baseline gap-2">
                  <span className="text-xs font-mono uppercase tracking-[0.16em] text-muted-foreground w-16 shrink-0">
                    Email
                  </span>
                  <a
                    href="mailto:jorek@impli.de"
                    className="font-mono text-foreground hover:text-primary transition-colors"
                  >
                    jorek@impli.de
                  </a>
                </div>
                <div className="flex items-baseline gap-2">
                  <span className="text-xs font-mono uppercase tracking-[0.16em] text-muted-foreground w-16 shrink-0">
                    Tel.
                  </span>
                  <a
                    href="tel:+495619877696"
                    className="font-mono text-foreground hover:text-primary transition-colors"
                  >
                    +49 (0)561-9877696
                  </a>
                </div>
              </div>

              <div className="my-6 text-foreground/20">
                <div className="barcode-rule" />
              </div>

              <div className="space-y-1 text-sm text-muted-foreground">
                <p>Amtsgericht Paderborn, HRB 8602</p>
                <p>Geschäftsführer: Philipp Jorek</p>
                <p>Umsatzst.-Id: DE815003392</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <SiteFooter />
    </main>
  );
}
